export const store = {};
export const injectStore = (storeInstance, rootTypes) => {
  store.instance = storeInstance;
  store.rootTypes = rootTypes;
};
